import type { CriticalReview } from '../types/watchdog';

interface Props {
  review: CriticalReview;
}

function PassAssessment({ label, confirmed, rejected, refined, missed }: {
  label: string;
  confirmed: string[];
  rejected: string[];
  refined: string[];
  missed: string[];
}) {
  return (
    <div className="critical-review-block__pass">
      <h5 className="critical-review-block__pass-label">{label}</h5>
      {confirmed.length > 0 && (
        <div className="critical-review-block__col critical-review-block__col--confirmed">
          <strong>✓ Potvrzeno</strong>
          <ul>{confirmed.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </div>
      )}
      {rejected.length > 0 && (
        <div className="critical-review-block__col critical-review-block__col--rejected">
          <strong>✗ Vyvráceno</strong>
          <ul>{rejected.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </div>
      )}
      {refined.length > 0 && (
        <div className="critical-review-block__col critical-review-block__col--refined">
          <strong>◐ Zpřesněno</strong>
          <ul>{refined.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </div>
      )}
      {missed.length > 0 && (
        <div className="critical-review-block__col critical-review-block__col--missed">
          <strong>+ Přehlédnuto předchozím kolem</strong>
          <ul>{missed.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </div>
      )}
    </div>
  );
}

export function CriticalReviewBlock({ review }: Props) {
  return (
    <section className="critical-review-block">
      <h4>Kritické srovnání s předchozími koly</h4>
      <PassAssessment
        label="Stage 1 (rychlé čtení)"
        confirmed={review.first_pass_assessment.confirmed}
        rejected={review.first_pass_assessment.rejected}
        refined={review.first_pass_assessment.refined}
        missed={review.first_pass_assessment.missed_by_first_pass}
      />
      <PassAssessment
        label="Stage 2 (strukturovaná analýza)"
        confirmed={review.second_pass_assessment.confirmed}
        rejected={review.second_pass_assessment.rejected}
        refined={review.second_pass_assessment.refined}
        missed={review.second_pass_assessment.missed_by_second_pass}
      />
      {review.divergence_summary && (
        <blockquote className="critical-review-block__divergence">
          {review.divergence_summary}
        </blockquote>
      )}
    </section>
  );
}
